export default {
  state: {
    rsvp: null
  },
  mutations: {
    setRsvp (state, value) { state.rsvp = value },
    updateLyftStatus (state, value) {
      if (state.rsvp.lyft) {
        state.rsvp.lyft.status = value
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-track/reservation.js